import React from 'react';
import { Helmet } from "react-helmet";

function About() {
  const teamMembers = [
    {
      id: 1,
      name: 'Sofia Martini',
      role: 'Direttrice Editoriale',
      bio: 'Esperta di letteratura italiana con oltre 15 anni di esperienza nel settore editoriale. Appassionata di classici e narrativa contemporanea.',
      image: '/images/team_1.jpg'
    },
    {
      id: 2,
      name: 'Elena Rossi',
      role: 'Critica Letteraria',
      bio: 'Laureata in Lettere Moderne, specializzata in letteratura contemporanea. Collabora con diverse riviste letterarie nazionali.',
      image: '/images/team_2.jpg'
    },
    {
      id: 3,
      name: 'Marco Bianchi',
      role: 'Esperto di Cancelleria',
      bio: 'Artigiano e studioso della storia della cancelleria. Esperto in rilegatura artigianale e strumenti di scrittura di pregio.',
      image: '/images/team_3.jpg'
    },
    {
      id: 4,
      name: 'Francesca Lombardi',
      role: 'Bibliotecaria e Ricercatrice',
      bio: 'Specializzata in biblioteche storiche e conservazione del patrimonio librario. Appassionata di manoscritti antichi e incunaboli.',
      image: '/images/team_4.jpg'
    },
    {
      id: 5,
      name: 'Giuseppe Ferrara',
      role: 'Responsabile Contenuti',
      bio: 'Giornalista culturale con esperienza ventennale. Coordina la redazione e cura la qualita dei contenuti pubblicati sul blog.',
      image: '/images/team_5.jpg'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Bolanir - Libreria e Cartoleria Blog</title>
        <meta name="description" content="Bolanir - Il tuo blog dedicato alla letteratura, libri curati e cancelleria di qualita. Scopri recensioni, consigli di lettura e novita editoriali." />
      </Helmet>

      <div className="about-page">
      <section className="about-intro">
        <h2>Chi Siamo</h2>
        <p>
          Bolanir e un blog nato dalla passione per i libri, la letteratura e l arte della scrittura. Siamo un gruppo di professionisti e appassionati che hanno dedicato la propria vita allo studio, alla promozione e alla diffusione della cultura letteraria in tutte le sue forme.
        </p>
        <p>
          La nostra missione e creare un ponte tra i lettori e il vasto mondo della letteratura, offrendo contenuti di qualita che spaziano dalle recensioni di nuove uscite editoriali alle analisi approfondite dei grandi classici, dalle guide alla cancelleria di pregio alle esplorazioni delle biblioteche storiche italiane.
        </p>
        <p>
          Crediamo fermamente che la lettura sia uno strumento fondamentale di crescita personale, un mezzo per ampliare i propri orizzonti, sviluppare il pensiero critico e arricchire la propria sensibilita. In un mondo sempre piu digitale, vogliamo valorizzare la bellezza del libro come oggetto fisico, il piacere della scrittura a mano e l importanza delle biblioteche come luoghi di conservazione della memoria collettiva.
        </p>
        <p>
          Il nostro team e composto da professionisti con competenze diverse ma accomunati dalla stessa passione: rendere la cultura letteraria accessibile, interessante e rilevante per tutti. Ogni membro porta la propria esperienza e il proprio punto di vista, creando un mosaico ricco e variegato di contenuti.
        </p>
        <p>
          Collaboriamo con editori, librerie, biblioteche e istituzioni culturali per offrire ai nostri lettori informazioni sempre aggiornate, accurate e approfondite. Organizziamo anche eventi, presentazioni di libri e incontri con autori per creare una comunita attiva e partecipe.
        </p>
      </section>

      <section className="team-section">
        <h2>Il Nostro Team</h2>
        <div className="team-grid">
          {teamMembers.map((member) => (
            <div key={member.id} className="team-card">
              <img 
                src={member.image} 
                alt={`${member.name} - ${member.role}`}
                className="team-photo"
                width="400"
                height="400"
              />
              <div className="team-info">
                <h3>{member.name}</h3>
                <p className="team-role">{member.role}</p>
                <p className="team-bio">{member.bio}</p>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  
    </>);
}

export default About;